import React, { useState, useEffect } from 'react';
import { Button, Input, Select, message, Form, InputNumber, Space, Row, Col, Tabs } from 'antd';
import useWebPost from '../../utils/useWebPost';
import { getAdmin, getobjkeys, getJsfs, getyhzh } from '../../utils/functions';
import FullHeightLayout from '../../components/FullHeightLayout';
import {  useParams } from 'react-router-dom';
import ImgUploader from "../../components/ImgUploader";
import DateInput from '../../components/DateInput';

const { Option } = Select;

const ReceiptForm = ({editItem, editsn, onSave}) => {
    const { sn } = useParams();
    const [form] = Form.useForm();
    const webPost = useWebPost();
    const [step, setStep] = useState(0);
    const [isloading, setIsloading] = useState(true);
    const [config, setConfig] = useState({});
    const [xmsn, setXmsn] = useState('');
    const [htCntent, setHtContent] = useState(null);
    const [kmdata, setKmdata] = useState([]);
    const can_mode = !(Number(localStorage.getItem(`st_${sn}`)) === 10 || Number(localStorage.getItem(`st_${editsn}`)) === 10);
    useEffect(() => {
        async function getCs() {
            const yhzh = await getyhzh(webPost);
            const admin = getAdmin();
            const kms = await webPost('cktypelist', {});
            if (kms) setKmdata(kms.filter(it => it.km.toLowerCase().includes('lk')));
            form.setFieldValue('maker_name', admin?.name);
            setConfig(prev => ({ ...prev, yhzh, jsfs: getJsfs(), }));
        }
        getCs();
        return undefined;
    }, []);
    useEffect(() => {
        if (editItem) {
            console.log(editItem);
            setXmsn(editItem.sn);
            form.setFieldsValue(editItem);
            setHtContent(null);
            setStep(1);
        } else {
            if (editsn){
                getXminfo(editsn);
            } else if(sn){
                getXminfo(sn);
            }
        }

        return undefined;
    }, [sn, editItem]);


    const saveSubmit = async (sh) => {
        if(!can_mode)return;
        try {
            const values = await form.validateFields();
            const id = (editItem && editItem.id) || 0;
            const res = await webPost('receiptsq', {
                ...values, id: id, sh, sn: xmsn
            });
            if (res) {
                message.success('保存成功');
                if (id === 0) form.resetFields();
                if (onSave) onSave();
            }
        } catch (errorInfo) {
            console.log('校验失败', errorInfo);
            message.error('请检查表单填写内容，有必填项未填或格式错误！');
            const firstErrorItem = document.querySelector('.ant-form-item-has-error');

            if (firstErrorItem) {
                firstErrorItem.scrollIntoView({
                    behavior: 'smooth', // 平滑滚动
                    block: 'center'    // 居中显示，防止被顶部导航栏遮挡
                });
            }
        }
        return;
    };
    const getXmxx = async () => {
        await getXminfo(form.getFieldValue('sn'));
    }
    const getXminfo = async (s) => {
        const res = await webPost('getCwxxBySn', { sn: s });
        if (res) {
            setXmsn(s);
            setHtContent(res);
            form.setFieldsValue({...res, invoiced_amount:res?.xxk});
            setStep(1);
        }
    }
    const setpayer = async (v) => {
        if (!htCntent) {
            form.setFieldValue('payer_name', '');
            form.setFieldValue('payer_account', '');
            form.setFieldValue('payer_bank', '');
            return;
        }
        switch (v) {
            case '建设单位来款':
                form.setFieldValue('payer_name', htCntent?.js_name);
                form.setFieldValue('payer_account', htCntent?.js_account);
                form.setFieldValue('payer_bank', htCntent?.js_bank);
                break;
            case "个人来款":
                form.setFieldValue('payer_name', htCntent?.kh_name);
                form.setFieldValue('payer_account', htCntent?.kh_account);
                form.setFieldValue('payer_bank', htCntent?.kh_bank);
                break;
            default:
                form.setFieldValue('payer_name', '');
                form.setFieldValue('payer_account', '');
                form.setFieldValue('payer_bank', '');
                break;
        }
    }
    return (
        <FullHeightLayout
            headerContent={null}
            footerContent={
                step === 1 && can_mode && (<Row justify="center" style={{ width: '90%' }}>
                    <Col>
                        <Button type="link" onClick={() => saveSubmit(0)}>保存为草稿</Button>
                        <Button type="primary" onClick={() => saveSubmit(1)}>保存并提交</Button>
                    </Col>
                </Row>)
            }
        >
            <Form form={form} layout="vertical" loading={isloading}>
                {step === 0 && (<>
                    <Form.Item label="项目编号" name="sn">
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" onClick={getXmxx}>下一步</Button>
                    </Form.Item>
                </>)}
                {step === 1 && (<>
                    <h3>收款方</h3>
                    <div className='responsive-grid'>
                        <Form.Item label="收款单位" name="bank_id" rules={[{ required: true }]}>
                            <Select placeholder="选择收款单位" onChange={(value) => {
                                const matched = config?.yhzh.find(it => Number(it.id) === Number(value)); // 或者 it.id === value
                                if (matched) {
                                    form.setFieldsValue({ receipt_account: matched.zh });
                                    form.setFieldsValue({ receipt_company: `${matched.dw}-${matched.mc}` });
                                }
                            }}>{config?.yhzh && config.yhzh.map(it => {
                                return <Option key={it.id} value={it.id}>{`${it.dw}-${it.mc}-${it.zh}`}</Option>
                            })}</Select>
                        </Form.Item>
                        <Form.Item label="收款账号" name="receipt_account" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="制单人" name="maker_name" rules={[{ required: true }]}>
                            <Input readOnly />
                        </Form.Item>
                        <Form.Item label="制单日期" name="make_date" rules={[{ required: true }]}>
                            <DateInput showTime={false} />
                        </Form.Item>
                    </div>
                    <h3>付款方</h3>
                    <div className='responsive-grid'>
                        <Form.Item label="收入类别" name="income_type" rules={[{ required: true }]}>
                            <Select placeholder="选择收入类别" onChange={(v) => setpayer(v)}>
                                <Option value='个人来款'>个人来款</Option>
                                <Option value='建设单位来款'>建设单位来款</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item label="结算方式" name="settlement_method" rules={[{ required: true }]}>
                            <Select placeholder="选择结算方式">{config?.jsfs && config.jsfs.map(it => <Option key={it.id} value={it.name}>{it.name}</Option>)}</Select>
                        </Form.Item>
                        <Form.Item label="付款户名" name="payer_name" rules={[{ required: true }]}><Input /></Form.Item>
                        <Form.Item label="付款账号" name="payer_account" rules={[{ required: true }]}><Input /></Form.Item>
                        <Form.Item label="付款银行" name="payer_bank" rules={[{ required: true }]}><Input /></Form.Item>
                        <Form.Item label="费用科目" name="km" rules={[{ required: true }]}>
                            <Select
                                showSearch // 开启搜索功能
                                placeholder="输入科目代码或名称进行搜索"
                                optionFilterProp="label" // 指定搜索时匹配的是 label 属性
                                filterOption={(input, option) => {
                                    const inputLower = input.toLowerCase();
                                    const km = option.km?.toString().toLowerCase() || '';
                                    const kmmc = option.kmmc?.toLowerCase() || '';
                                    return km.includes(inputLower) || kmmc.includes(inputLower);
                                }}
                                onChange={(value) => {
                                    const matched = kmdata.find(it => it.km === value);
                                    if (matched) {
                                        form.setFieldsValue({ kmmc: matched.kmmc });
                                    }
                                }}
                            >
                                {kmdata?.map((item) => (
                                    <Select.Option
                                        key={item.km}
                                        value={item.km} // 假设表单最终存的是科目代码 km
                                        km={item.km} // 通过属性把数据传进去，供 filterOption 使用
                                        kmmc={item.kmmc}
                                        label={`${item.km} ${item.kmmc}`} // 这是给 showSearch 默认搜索用的文本
                                    >
                                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                                            <span>{item.km}</span>
                                            <span style={{ color: '#666', fontSize: '12px' }}>{item.kmmc}</span>
                                        </Space>
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="备注" name="remark"><Input.TextArea maxLength={450} showCount /></Form.Item>
                    </div>
                    <h3>业务明细</h3>
                    <div className='responsive-grid'>
                        <Form.Item label="本次收款金额" name="this_receipt_amount" rules={[{ required: true }]}><Input /></Form.Item>
                        <Form.Item label="项目名称" name="xmmc" rules={[{ required: true }]} ><Input readOnly /></Form.Item>
                        <Form.Item label="合同总额" name="contract_amount"><Input readOnly /></Form.Item>
                        <Form.Item label="已开票金额" name="invoiced_amount"><Input type="number" readOnly /></Form.Item>
                        <Form.Item label="已来款金额" name="received_amount"><Input type="number" readOnly /></Form.Item>
                    </div>

                    <Form.Item label="附件" name="attachment"><ImgUploader /></Form.Item>
                    <Form.Item hidden name={'kmmc'}><Input /></Form.Item>
                    <Form.Item hidden name={'receipt_company'}><Input /></Form.Item>

                </>)}



            </Form >
        </FullHeightLayout >
    );
};

export default ReceiptForm;